export default {"src":"/_next/static/media/get_colearn_on_google_play.e9282882.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};